module.exports = __webpack_public_path__ + "img/advice-connect.svg?5434dfba475a6351eef976d2f80844ee";